__turbopack_context__.v({
  "bullets": "MultiVendorArchitecture-module___788JW__bullets",
  "card": "MultiVendorArchitecture-module___788JW__card",
  "cardWrap": "MultiVendorArchitecture-module___788JW__cardWrap",
  "core": "MultiVendorArchitecture-module___788JW__core",
  "core-left": "MultiVendorArchitecture-module___788JW__core-left",
  "core-right": "MultiVendorArchitecture-module___788JW__core-right",
  "customers": "MultiVendorArchitecture-module___788JW__customers",
  "diagram": "MultiVendorArchitecture-module___788JW__diagram",
  "down-left": "MultiVendorArchitecture-module___788JW__down-left",
  "down-right": "MultiVendorArchitecture-module___788JW__down-right",
  "flowX": "MultiVendorArchitecture-module___788JW__flowX",
  "grid": "MultiVendorArchitecture-module___788JW__grid",
  "head": "MultiVendorArchitecture-module___788JW__head",
  "inView": "MultiVendorArchitecture-module___788JW__inView",
  "integrations": "MultiVendorArchitecture-module___788JW__integrations",
  "l1": "MultiVendorArchitecture-module___788JW__l1",
  "l2": "MultiVendorArchitecture-module___788JW__l2",
  "l3": "MultiVendorArchitecture-module___788JW__l3",
  "l4": "MultiVendorArchitecture-module___788JW__l4",
  "left": "MultiVendorArchitecture-module___788JW__left",
  "link": "MultiVendorArchitecture-module___788JW__link",
  "logoChip": "MultiVendorArchitecture-module___788JW__logoChip",
  "logoRail": "MultiVendorArchitecture-module___788JW__logoRail",
  "logoTrack": "MultiVendorArchitecture-module___788JW__logoTrack",
  "node": "MultiVendorArchitecture-module___788JW__node",
  "payments": "MultiVendorArchitecture-module___788JW__payments",
  "pulse": "MultiVendorArchitecture-module___788JW__pulse",
  "rail": "MultiVendorArchitecture-module___788JW__rail",
  "railInner": "MultiVendorArchitecture-module___788JW__railInner",
  "right": "MultiVendorArchitecture-module___788JW__right",
  "section": "MultiVendorArchitecture-module___788JW__section",
  "split": "MultiVendorArchitecture-module___788JW__split",
  "subtitle": "MultiVendorArchitecture-module___788JW__subtitle",
  "title": "MultiVendorArchitecture-module___788JW__title",
  "travel": "MultiVendorArchitecture-module___788JW__travel",
  "vendors": "MultiVendorArchitecture-module___788JW__vendors",
  "wrap": "MultiVendorArchitecture-module___788JW__wrap",
});
